var React = require('react');

function IconCheckWildDark (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Supported"),React.createElement("path",{"d":"M1.5 7L6.65625 12.25L16.5 1.75","stroke":"#008078","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

IconCheckWildDark.defaultProps = {"width":"18","height":"14","viewBox":"0 0 18 14","fill":"none"};

module.exports = IconCheckWildDark;

IconCheckWildDark.default = IconCheckWildDark;
